import { format } from 'date-fns'
import { es } from 'date-fns/locale'

/**
 * Acepta ISO 8601, Date object, o cualquier string que `new Date()` parsee
 * (incluida la salida de `Date.toString()` que devuelve hoy el backend de
 * organización). Retorna `null` si el resultado es inválido.
 */
function toDate(input: string | Date): Date | null {
  const d = typeof input === 'string' ? new Date(input) : input
  return Number.isNaN(d.getTime()) ? null : d
}

/** Formato corto: `25 may 2026`. */
export function formatDate(date: string | Date, pattern = 'dd MMM yyyy'): string {
  const d = toDate(date)
  if (!d) return typeof date === 'string' ? date : ''
  return format(d, pattern, { locale: es })
}

/** Formato con hora: `25 may 2026, 21:05`. */
export function formatDateTime(
  date: string | Date,
  pattern = 'dd MMM yyyy, HH:mm',
): string {
  const d = toDate(date)
  if (!d) return typeof date === 'string' ? date : ''
  return format(d, pattern, { locale: es })
}

/**
 * Formato corto seguro para fechas. Retorna `fallback` cuando el input es
 * `null`/`undefined`/`''`. `formatDate` ya tolera strings no-parseables sin
 * lanzar (retorna el original), por lo que no se necesita try/catch aquí.
 */
export function safeFormatDate(
  value: string | Date | null | undefined,
  fallback = '',
): string {
  if (!value) return fallback
  return formatDate(value)
}

/** Igual que `safeFormatDate` pero con hora (`25 may 2026, 21:05`). */
export function safeFormatDateTime(
  value: string | Date | null | undefined,
  fallback = '',
): string {
  if (!value) return fallback
  return formatDateTime(value)
}
